import { useState, Fragment,createContext, useContext  } from 'react';

const PriceContext = createContext();

const PriceProvider = ({ children }) => {
  const [price, setPrice] = useState(0);
  const [authenticaed, setAuth] = useState(null);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [credit, setCredit] = useState();
  const [disabled, setDisable] = useState(false);
  const [message, setMessage] = useState(null);
  const [email, setEmailCon] = useState(null);
  const [sub, setSub] = useState(null);
  const [teamCount, setTeamCount] = useState(0);
    const [teams, setTeams] = useState(0);
    const [subscribedTeams, setSubTeams] = useState([]);


  const [subs, setSubs] = useState([]);




  return (
    <PriceContext.Provider value={{ teamCount, setTeamCount, price, setPrice, isAuthenticated, userHasAuthenticated, credit, setCredit,disabled, setDisable, message, setMessage,email, setEmailCon, sub, setSub, teams, setTeams,subs, setSubs, subscribedTeams, setSubTeams}}>
      {children}
    </PriceContext.Provider>
  );
  }
  export {PriceContext, PriceProvider}